import { HttpClient, HttpHeaders } from "@angular/common/http";
import * as api from './apihandler';
import { Observable } from 'rxjs';
import { OfferFromCompany, OfferOnExistingCase } from "../models/document-models";
import { GetOffer } from "app/shared-html-components/document-creator/productGrid";

export class OfferApi {
    bearer = localStorage.getItem('bearer') as string;
    constructor(private http: HttpClient) { }

    getOffer(offerId: string){
        return new Promise((resolve, reject)=> {
            const headers = new HttpHeaders({ 'Authorization': this.bearer });
            this.http.get(api.jubloApi + 'api/Website/Offer/' + offerId, { headers }).subscribe({
                next:(data: GetOffer)=> resolve(data),
                error:(err) => {
                    console.error(`Offer couldn't load`)
                    reject(null)
                }
            });
        })
    }

    getTradeGroups() {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Website/Offer/GetTradeGroups', { headers });
    }

    getEstablishedBy() {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Website/Offer/GetEstablishedBy', { headers });
    }

    offerFromCompany(offer: OfferFromCompany) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post(api.jubloApi + 'api/Website/OfferRequest/OfferFromCompany', offer, { headers });
    }

    offerOnExistingCase(doc: OfferOnExistingCase) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post(api.jubloApi + 'api/Website/Offer/CreateOfferOnExistingCase', doc, { headers });
    }

    updateDescriptions(offerId: string, description: string | null, technicalDescription: string | null): Observable<any> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.patch(api.jubloApi + `api/Website/Offer/UpdateCaseOfferDescriptions/${ offerId }`, { description: description, technicalDescription: technicalDescription }, { headers });
    }

    deleteDocument(documentId:string){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.delete(api.jubloApi + `api/Website/Offer/DeleteOffer/${ documentId }`, {headers});
    }
}

export class OfferFunctions {

}